import { Deal, DealStateEnum } from '../gql/dealGql';
import { Maybe, Tag, TagsPayload } from '../gql/generated/graphql';

import { Swimlane } from './dashboard';

type UpdateDealTagsFn = (currentTags: Maybe<Tag[]>, tags: Tag[]) => Tag[];

export const mergeCreatedTags: UpdateDealTagsFn = (currentTags, newTags) => {
  const existing = currentTags ?? [];
  const existingIds = new Set(existing.map((t) => String(t.id)));
  const uniqueNewTags = newTags?.filter((t) => !existingIds.has(String(t.id)));
  return [...existing, ...(uniqueNewTags ?? [])];
};

export const filterDeletedTags: UpdateDealTagsFn = (currentTags, deletedTags) => {
  const existing = currentTags ?? [];
  const deletedIds = new Set(deletedTags?.map((t) => String(t.id)));
  return existing.filter((t) => !deletedIds.has(String(t.id)));
};

type UpdateDealTagsParams = {
  deals: Deal[];
  tagsPayload: Maybe<TagsPayload>;
  updateFn: UpdateDealTagsFn;
};
export const updateDealTags = ({ deals, tagsPayload, updateFn }: UpdateDealTagsParams): Deal[] => {
  const { dealId, tags } = tagsPayload ?? {};
  if (!dealId || !tags?.length) {
    return deals;
  }

  const index = deals.findIndex((d) => String(d.id) === String(dealId));
  if (index === -1) {
    return deals;
  }

  const updated = [...deals];
  updated[index] = {
    ...updated[index],
    tags: updateFn(updated[index].tags, tags),
  };
  return updated;
};

type UpdateSwimlanesDealTagsParams = {
  swimlane: Swimlane;
  tagsPayload: Maybe<TagsPayload>;
  updateFn: UpdateDealTagsFn;
};
export const updateSwimlanesDealTags = ({
  swimlane,
  tagsPayload,
  updateFn,
}: UpdateSwimlanesDealTagsParams) => {
  const { dealId, tags } = tagsPayload ?? {};
  if (!dealId || !tags?.length) {
    return swimlane;
  }

  const laneKeys = Object.keys(swimlane) as DealStateEnum[];
  let dealIndex = -1;
  const laneKey = laneKeys.find((key) => {
    const index = swimlane[key].findIndex((d) => String(d.id) === String(dealId));
    if (index !== -1) {
      dealIndex = index;
      return true;
    }
    return false;
  });
  if (!laneKey || dealIndex === -1) {
    return swimlane;
  }

  const deal = swimlane[laneKey][dealIndex];
  const updatedLane = [...swimlane[laneKey]];
  updatedLane[dealIndex] = {
    ...deal,
    tags: updateFn(deal.tags, tags),
  };

  return { ...swimlane, [laneKey]: updatedLane };
};
